import React from 'react'
import SideBar from '../SideBar/SideBar'
import { Box } from '@mui/material'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className='layout'>
      <SideBar />
      <Box className="common-layout flex-column d-flex" sx={ { flex: 1, overflow:"hidden"} }>
        <Header />
        <Box className="d-flex flex-column w-100" sx={{ overflow: 'auto', flex: 1 }}>
          <main className='p-4' style={{ flex: 1 }}>{children}</main>
          <Box>
          <Footer />
          </Box>
          </Box>
        </Box>
    </div>
  )
}

export default Layout
